<template>
  <nav class="main" v-bind:class='{searchshowing: searchShowing}'>
    <div class="menu-inner">
      <ul class="primary-links">
        <li class="logo"><router-link :to="'/'"><img src="../assets/logo.svg"></router-link></li>
        <li class="search">
            <i class="material-icons" @click='searchShowing = !searchShowing'>search</i>
                <span v-if='!searchShowing' @click='searchShowing = true'>Search</span>
            <transition name="stretch">
                <Autocomplete v-if='searchShowing' :searchPlaceholder="'Search...'" :styling="'inheader'" @searchBlur='searchShowing = false' @select='searchSelect' />
            </transition>
        </li>
        <li class="browse"><router-link :to="'/browse'"><i class="material-icons">apps</i> <span>Browse</span></router-link></li>
      </ul>
      <ul class="secondary-links">
        <li class="phonenumber"><a href="tel:3238740404">(323) 874-0404</a></li>
        <li @click="$emit('accountClick')" class="account"><i class="material-icons mobile">person</i> <span>Account</span></li>
        <li @click="$emit('pullSheetClick')"><i class="material-icons mobile">photo_library</i> <i class="material-icons desktop">arrow_drop_down</i> <span>Pullsheet</span></li>
      </ul>
    </div>
  </nav>
</template>

<script>
import Autocomplete from './Autocomplete'
export default {
  name: 'MainMenu',
  props: [
    'userName'
  ],
  data () {
    return {
      searchShowing: false,
      pullSheet: this.$root.pullSheet
    }
  },
  methods: {
    showSearch: function () {
    },
    searchSelect: function (option) {
      if (option.plcount !== undefined) {
        this.$router.push('/browse/' + option.slug)
        return false
      }
      if (option.plno !== undefined) {
        this.$router.push('/location/' + option.plno)
        return false
      }
      this.searchShowing = false
    }
  },
  events: {
    addToPullSheet: function (data) {
    }
  },
  components: {
    Autocomplete
  },
  watch: {
    'pullSheet': {
      handler: function (val, oldVal) {
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/_mixins.scss";
nav.main {
  position: fixed;
  z-index: 100;
  top: 0px;
  left: 0px;
  height: 48px;
  background: $yellow;
  font-family: $noto;
  width: 100%;
  text-transform: uppercase;
  @include noselect();
  box-shadow:
    0px 1px 0px 0px #F5F4ED,
    0px 2px 0px 0px #D3D2CF;
}
  img {
    width: 109px;
    height: 29px;
    @include bp(most) {
      height: 36px;
      width: 132px;
    }
  }

  ul.primary-links {
    float: left;
    font-weight: 600;
    li {
      line-height: 48px;
      a {
        text-decoration: none;
        color: $notblack;
      }
    }
    li.logo {
        @include bp(mobile) {
          position: absolute;
          left: 50%;
          margin-left: -55px;
          top: 10px;
        }
        @include bp(most) {
          padding: 6px 0 0 11px;
        }
    }
    li.search {
      margin-left: 16px;
      cursor: pointer;
      float: left;
      @include bp(most) {
        float: none;
        margin-left: 42px;
      }
    }
    li.browse {
      margin-left: 4px;
      @include bp(most) {
        margin-left: 27px;
      }
    }
    .material-icons {
      font-size: 18px;
      vertical-align: middle;
      margin-top: -3px;
      margin-right: 3px;
    }
  }

  ul.secondary-links {
    float: right;
    li {
      line-height: 48px;
      font-weight: 600;
      cursor: pointer;
      margin-right: 16px;
      @include bp(mobile) {
        &.account {
          margin-right: 4px;
        }
      }
      @include bp(most) {
        margin-right: 16px;
      }
      @include bp(medlarge) {
        margin-right: 26px;
      }
      &.phonenumber {
        margin-right: 20px;
        font-weight: 400;
        display: none;
        @include bp(most) {
          display: inline-block;
        }
        @include bp(medlarge) {
          margin-right: 42px;
        }
      }
      .material-icons {
        font-size: 18px;
        vertical-align: middle;
        margin-top: -3px;
        margin-right: -3px;
      }
    }
    a {
      text-decoration: none;
      color: $notblack;
    }
  }

  ul, li {
    list-style-type: none;
    margin: 0px;
    padding: 0px;
    display: inline-block;
    vertical-align: top;
    span {
      display: none;
      @include bp(most) {
        display: inline;
      }
    }
  }

  @include bp(most) {
    nav.main.floating {
      background: none;
      box-shadow: none;
      color: #FFF;
      position: absolute;
      z-index: 999;
      padding: 2em 5% 0;
      box-sizing: border-box;
      ul.secondary-links a {
        color: #FFF;
      }
      li.search, li.browse {
        display: none;
      }
      .phonenumber {
        font-weight: 600;
      }
      li.logo img {
        width: 150px;
        height: 40px;
      }
    }
  }

  .autocomplete-input.stretch-enter-active {
    transition: all .5s;
  }
  .autocomplete-input.stretch-enter {
    opacity: 0;
    width: 54px;
  }
  .autocomplete-input {
    opacity: 1;
    display: inline-block;
    width: 260px;
    @include bp(most) {
      width: 250px;
    }
  }

  i.mobile {
    display: inline-block;
    @include bp(most) {
      display: none;
    }
  }
  i.desktop {
    display: none;
    @include bp(most) {
      display: inline-block;
    }
  }

  @include bp(mobile) {
    nav.main.searchshowing {
      ul li {
        display: none;
      }
      ul li.search {
        display: inline-block;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// MainMenu.vue?37abbaf2